import { IOptionItem } from "./FormikAutocomplete.types";

export function toOptionItems(values: string[]): IOptionItem[] {
  return values.map((v) => ({ id: v, label: v }));
}
